import { createContext } from 'react'

export type Theme = 'light' | 'dark'

export interface ThemeContextValue {
  theme: Theme
  setTheme: (theme: Theme) => void
  toggleTheme: () => void
}

/** Key shared with the inline bootstrap script in index.html. */
export const THEME_STORAGE_KEY = 'cbs.theme'

export const ThemeContext = createContext<ThemeContextValue | null>(null)
